(() => {
 'use strict';
 const initialized = new WeakSet();
 function init(root){
  if(initialized.has(root))return;
  const grid=root.querySelector('[data-hz-size-grid]');
  const message=root.querySelector('[data-hz-message]');
  const submit=root.querySelector('[data-hz-submit]');
  const original=grid?.querySelector('[data-hz-size]');
  if(!grid||!original||!original.options.length||!submit||!message) return;
  initialized.add(root);
  root.dataset.hzReady='true';
  const idleLabel=submit.textContent;
  const announce=()=>root.dispatchEvent(new CustomEvent('hz:bundle-change',{bubbles:true}));
  const template=original.parentElement.cloneNode(true);
  const tiers=[...root.querySelectorAll('input[type="radio"][name^="hz-bundle"]')];
  function change(){
   const selected=tiers.find(r=>r.checked);
   const quantity=Number(selected?.value||1);
   for(const card of root.querySelectorAll('[data-hz-tier]')) card.classList.toggle('is-checked',Number(card.dataset.hzTier)===quantity);
   while(grid.children.length<quantity){const copy=template.cloneNode(true);grid.appendChild(copy);}
   while(grid.children.length>quantity)grid.lastElementChild.remove();
   [...grid.children].forEach((node,i)=>{
     const label=node.querySelector('span');const select=node.querySelector('select');
     if(label) label.textContent=(root.dataset.hzCloak+' ')+(i+1);
     if(select){select.setAttribute('aria-label',(root.dataset.hzCloak+' ')+(i+1)+(' '+root.dataset.hzSize));select.name='hz-variant-'+i}
   });
   announce();
  }
  grid.addEventListener('change',announce);
  tiers.forEach(r=>r.addEventListener('change',change));
  change();
  submit.addEventListener('click',async()=>{
   if(submit.disabled)return;
   const sizes=[...grid.querySelectorAll('[data-hz-size]')];
   if(!sizes.length)return;
   const tally=new Map();
   for(const select of sizes){const id=Number(select.value);if(!Number.isInteger(id)||!id){message.textContent=root.dataset.hzChoose;return;}tally.set(id,(tally.get(id)||0)+1)}
   const items=[...tally].map(([id,quantity])=>({id,quantity}));
   submit.disabled=true;submit.textContent=root.dataset.hzAdding;message.textContent='';announce();
   try{
    const rootPath=window.Shopify?.routes?.root || '/';
    const resp=await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
    if(!resp.ok){const e=await resp.json().catch(()=>({description:root.dataset.hzError}));throw new Error(e.description||e.message||root.dataset.hzError);}
    window.location.assign(rootPath+'cart');
   }catch(e){message.textContent=e.message||root.dataset.hzError;submit.disabled=false;submit.textContent=idleLabel;announce();}
  });
 }
 const run=()=>document.querySelectorAll('[data-hz-bundles]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
 document.addEventListener('shopify:section:load',run);
})();
